var klaviyo = klaviyo || [];
klaviyo.init({
  account: 'Uv4ZuA',
  platform: 'shopify',
});
klaviyo.enable('backinstock', {
  trigger: {
    product_page_text: 'Sold out | Notify Me When Available',
    product_page_class: 'btn',
    replace_anchor: false,
  },
  modal: {
    headline: '{product_name}',
    body_content: 'Register to receive a notification when this item comes back in stock.',
    email_field_label: 'Email',
    button_label: 'Notify me when available',
    subscription_success_label: "You're in! We'll let you know when it's back.",
    footer_content: '',
    drop_background_color: '#0A0800',
    background_color: '#fff',
    text_color: '#222',
    button_text_color: '#0A0800',
    button_background_color: '#FDC131',
    button_text_transform: 'uppercase',
    close_button_color: '#0A0800',
    error_background_color: '#0A0800',
    error_text_color: '#C72E2F',
    success_background_color: '#d3efcd',
    success_text_color: '#1B9500',
  },
});

document.querySelectorAll('.toggle-1-product-variation').forEach((el) => {
  if ((el.dataset.index = 'variant-1' && el.classList.contains('active'))) {
    console.log('should now hide');

    document.querySelector('.btn klaviyo-bis-trigger')?.style.setProperty('display', 'none');
  }
});
